<template lang="pug">
  main
    NavBarSoporte
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Atender Ticket
              | &nbsp
              a.button.is-black.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns
          .column.is-12
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Ticket
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  CardTicket(:ticket="ticketAtendido")
        .columns(v-show='ticketAtendido.estado === 0 && !ticketAtendido.authorized')
          .column.is-12.text-centered
            span.tag.is-danger Este Ticket aún no ha sido atendido
        .columns(v-show='ticketAtendido.estado < 2 && ticketAtendido.authorized')
          .column.is-12
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Formulario de Resolución
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  FormResolucion(:ticketBD="ticketAtendido" @saveForm="saveForm" @upateForm="upateForm")
        .columns(v-show='ticketAtendido.estado > 0 && !ticketAtendido.authorized || ticketAtendido.estado >= 3')
          .column.is-12
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Resolución
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  CardResolucion(:ticket='ticketAtendido')
        .columns.column-blanco
</template>

<script>
  import Loader from '@/components/shared/Loader.vue'
  import NavBarSoporte from '@/components/soporte_Componentes/NavBarSoporte.vue'
  import CardTicket from '@/components/soporte_Componentes/CardTicket.vue'
  import FormResolucion from '@/components/soporte_Componentes/FormResolucion.vue'
  import CardResolucion from '@/components/soporte_Componentes/CardResolucion.vue'
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
  import moment from 'moment'
  
  import ticketServices from '@/services/soporte/tickets'
  import { mapState } from 'vuex'

  export default {
    name: 'Atender',
    components: { Loader, NavBarSoporte, CardTicket, FormResolucion, BulmaAccordion, BulmaAccordionItem, CardResolucion },
    data() {
      return {
        isLoading: true
      }
    },
    methods: {
      iniciarComponente() {
        this.isLoading = false
      },
      backPage() {
        this.$store.commit('atenderTicket', {})
        this.$router.back()
      },
      saveForm(data) {
        this.isLoading = true
        let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
        let compraInt
        data.compra ? compraInt = 1 : compraInt = 0
        ticketServices.saveResolucion(this.ticketAtendido.id, fechaReg, data.fechaResolucion, data.id_diagnostico, data.restante, compraInt, data.comentarios, this.userLogin.id, this.userLogin.nombre, data.file)
          .then((resp) => {
            if (resp.success) {
              this.displayToast(resp.respuesta, 'done', 'OK')
              this.$router.push('/Soporte')
            } else {
              this.displayToast(resp.respuesta, 'ban', 'OK')
            }
            this.isLoading = false
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast(e.message, 'ban', 'OK')
          })
      },
      upateForm(formUpd) {
        let compraInt
        formUpd.compra ? compraInt = 1 : compraInt = 0
        this.isLoading = true
        ticketServices.updateResolucion(this.ticketAtendido.idResolucion, this.ticketAtendido.id, formUpd.fechaResolucion, formUpd.id_diagnostico, formUpd.restante, compraInt, formUpd.comentarios, formUpd.file, this.ticketAtendido.evidencia)
          .then((data) => {
            this.displayToast(data.respuesta, data.success? 'done' : 'ban', 'OK')
            this.backPage()
          })
          .catch((e) => {
            this.displayToast(e.message, 'ban', 'OK')
          })
          this.isLoading = false
      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, {
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
    ...mapState(['logueado', 'userLogin', 'ticketAtendido'])
  }
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/soporte_Componentes/Atender.vue